import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Formik, Form, Field } from "formik";

const PreEmptionRights = ({ onSubmit }) => {
  const preEmptionRights = useSelector(
    (state) => state.shareAllotmentSlice.preEmptionRights
  );
  const [selectedOption, setSelectedOption] = useState("applies"); // Default to "applies"

  // Sync selectedOption with preEmptionRights from Redux slice on mount
  useEffect(() => {
    if (preEmptionRights) {
      setSelectedOption(preEmptionRights);
    } else {
      // If no value in Redux, set default and notify parent
      setSelectedOption("applies");
      if (onSubmit) {
        onSubmit("applies");
      }
    }
  }, [preEmptionRights, onSubmit]);

  const handleOptionChange = (value, form) => {
    // Only change if a different option is selected (no deselection)
    if (selectedOption !== value) {
      setSelectedOption(value);
      form.setFieldValue("preEmptionRights", value);
      if (onSubmit) {
        onSubmit(value);
      }
    }
  };

  return (
    <div className="w-full bg-white p-6 my-6 border border-gray-100 shadow">
      <Formik
        initialValues={{
          preEmptionRights: preEmptionRights || "applies", // Default to "applies"
        }}
        enableReinitialize={true}
      >
        {({ setFieldValue }) => (
          <Form>
            <h1 className="text-md leading-6 font-medium text-[#31415d] mb-6">
              Pre-emption Rights
            </h1>
            <div className="flex items-center space-x-40 mb-2 ml-4">
              <label className="flex items-center">
                <Field
                  type="radio"
                  name="preEmptionRights"
                  value="applies"
                  checked={selectedOption === "applies"}
                  onChange={() =>
                    handleOptionChange("applies", { setFieldValue })
                  }
                  className="h-4 w-4 text-sflPrimary focus:ring-[#31415d] border-gray-300"
                />
                <span className="ml-2">Applies</span>
              </label>
              <label className="flex items-center">
                <Field
                  type="radio"
                  name="preEmptionRights"
                  value="waived"
                  checked={selectedOption === "waived"}
                  onChange={() =>
                    handleOptionChange("waived", { setFieldValue })
                  }
                  className="h-4 w-4 text-sflPrimary focus:ring-[#31415d] border-gray-300"
                />
                <span className="ml-2">Has been waived</span>
              </label>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PreEmptionRights;
